function getClientPageData(pageDataId) {
  const id = pageDataId || 'modelData';
  const model = window.document.getElementById(id);
  return model === null ? { pageData: {} } : JSON.parse(model.innerHTML);
}

export {
  // eslint-disable-next-line import/prefer-default-export
  getClientPageData,
};
